module.exports = __webpack_public_path__ + "img/Folded_Paper_Eindhoven.ae7a9173.jpg";